import { z } from 'zod';

export const productNames = ['galatea', 'galateatv', 'galateatvEarlyAccess', 'harlequin'] as const;

export const productNameSchema = z.enum(productNames);

export type ProductName = z.infer<typeof productNameSchema>;
